export default __webpack_public_path__ + "static/hotblack-coffee-about2-4a7b87c33b8cfa45f1af34e73bbc6fbd.png";